import { BenefitDTOBenefitEnum, DocumentsDTO } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class ITLeasingBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ documents }: { documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.ItLeasing.toLowerCase();
    return [
      {
        title: 'subPage.employees',
        to: `/benefits/${benefit}`,
      },
      {
        title: 'IT_LEASING.settings.title',
        to: `/benefits/${benefit}/settings`,
        activePattern: `^/benefits/${benefit}/(settings|connect|learnMore)$`,
      },
    ];
  }
}
